import { render, staticRenderFns } from "./UiNumberStepper.vue?vue&type=template&id=2c728560&"
import script from "./UiNumberStepper.vue?vue&type=script&lang=js&"
export * from "./UiNumberStepper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports